import { useState, useEffect } from 'react';
import Markdown from 'markdown-to-jsx';
import Image from 'next/image';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { isTablet } from 'react-device-detect';
import classes from './IconCopyCardListBlock.module.scss';

export default function IconCopyCardListBlock(props) {
    const [mobileView, setMobileView] = useState();
    gsap.registerPlugin(ScrollTrigger);

    useEffect(() => {
        setMobileView(isTablet);

        ScrollTrigger.create({
            trigger: '.stickyText',
            start: 'top top',
            end: 'bottom bottom',
            pin: '.stickyImage'
        });
    }, []);

    /**
     * Component expects props at object key 0
     */
    if (!props[0]) return null;
    const {
        0: ComponentContentSiteImage,
        1: ComponentContentSiteCopy,
        2: ComponentListIconCopyCardList,
        3: ComponentFieldSiteBackgroundImage,
        4: ComponentContentCardTheme
    } = props;

    const imageData = ComponentContentSiteImage.image.data.attributes;
    const imagePosition = ComponentContentCardTheme.image_position;
    const customClass = ComponentContentCardTheme.custom_class;
    const backgroundImage = ComponentFieldSiteBackgroundImage?.background_image?.data?.attributes;

    return (
        <section
            className={`${classes.oSection} ${classes[imagePosition]} ${classes[customClass]} oBlock ${imagePosition}`}
        >
            <div className={`${classes.oContainer} container`}>
                {mobileView ? (
                    <div className={`${classes.oRow} row`}>
                        <div
                            className={`${classes.oColText} ${classes.stickyText} col-md-6 oTextColumn stickyText`}
                        >
                            <h2 className={`${classes.aTitle} fnt40`}>
                                {ComponentContentSiteCopy.title}
                            </h2>
                            <Markdown className={`${classes.aCopyText} fnt13f`}>
                                {ComponentContentSiteCopy.copy}
                            </Markdown>
                            <div className={`${classes.oCardListRegion}`}>
                                {ComponentListIconCopyCardList.features_cards.map((card) => {
                                    return (
                                        <div
                                            key={card.id}
                                            className={`${classes.oCard} ${classes[card.width]} ${
                                                classes[card.custom_class]
                                            }`}
                                        >
                                            <figure className={`${classes.mImage}`}>
                                                <Image
                                                    src={card.icon.data.attributes.url}
                                                    alt={card.icon.data.attributes.alternativeText}
                                                    width={card.icon.data.attributes.width}
                                                    height={card.icon.data.attributes.height}
                                                    className={classes.aImage}
                                                    aria-hidden="true"
                                                    layout="responsive"
                                                    priority="true"
                                                />
                                            </figure>
                                            <p className={`${classes.aTitle} fnt26`}>
                                                {card.title}
                                            </p>

                                            <Markdown className={`${classes.aCopyText} fnt13f`}>
                                                {card.description}
                                            </Markdown>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div
                            className={`${classes.oColImage} ${classes.stickyImage} col-md-6 oImageColumn stickyImage`}
                        >
                            <figure className={`${classes.mImage}`}>
                                <Image
                                    src={imageData.url}
                                    alt={`Chat Banner`}
                                    width={imageData.width}
                                    height={imageData.height}
                                    className={classes.aImage}
                                    aria-hidden="true"
                                    layout="responsive"
                                    priority="true"
                                />
                            </figure>
                        </div>
                    </div>
                ) : (
                    <div className={`${classes.oRow} row`}>
                        <div className={`${classes.oColText} col-md-6 oTextColumn`}>
                            <h2 className={`${classes.aTitle} fnt40`}>
                                {ComponentContentSiteCopy.title}
                            </h2>
                            <Markdown className={`${classes.aCopyText} fnt13f`}>
                                {ComponentContentSiteCopy.copy}
                            </Markdown>
                            <div className={`${classes.oCardListRegion}`}>
                                {ComponentListIconCopyCardList.features_cards.map((card) => {
                                    return (
                                        <div
                                            key={card.id}
                                            className={`${classes.oCard} ${classes[card.width]} ${
                                                classes[card.custom_class]
                                            }`}
                                        >
                                            <figure className={`${classes.mImage}`}>
                                                <Image
                                                    src={card.icon.data.attributes.url}
                                                    alt={card.icon.data.attributes.alternativeText}
                                                    width={card.icon.data.attributes.width}
                                                    height={card.icon.data.attributes.height}
                                                    className={classes.aImage}
                                                    aria-hidden="true"
                                                    layout="responsive"
                                                    priority="true"
                                                />
                                            </figure>
                                            <p className={`${classes.aTitle} fnt26`}>
                                                {card.title}
                                            </p>

                                            <Markdown className={`${classes.aCopyText} fnt13f`}>
                                                {card.description}
                                            </Markdown>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className={`${classes.oColImage} col-md-6 oImageColumn`}>
                            <figure className={`${classes.mImage}`}>
                                <Image
                                    src={imageData.url}
                                    alt={`Chat Banner`}
                                    width={imageData.width}
                                    height={imageData.height}
                                    className={classes.aImage}
                                    aria-hidden="true"
                                    layout="responsive"
                                    priority="true"
                                />
                            </figure>
                        </div>
                    </div>
                )}
            </div>
            <figure className={`${classes.oBackgroundImage}`}>
                <Image
                    src={backgroundImage?.url}
                    alt={backgroundImage?.alternativeText}
                    width={backgroundImage?.width}
                    height={backgroundImage?.height}
                    className={classes.aImage}
                    aria-hidden="true"
                    layout="responsive"
                    priority="true"
                />
            </figure>
        </section>
    );
}
